import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['slug']

  slugWarning() {
    let persistedSlug = this.slugTarget.dataset.slug

    if (this.slugTarget.value !== persistedSlug && persistedSlug !== undefined && persistedSlug !== '') {
      if (!confirm('Are you sure you want to change the slug? That will change the OBE URL.')) { // eslint-disable-line no-alert
        event.preventDefault();
      }
    }
  }
}
